module.exports = __webpack_public_path__ + "static/media/dge3.png.02ebf2ff.jpg";